import { API_URL } from "./api";

export const DEVICE_TOKEN_KEY = "device_token";
export const DEVICE_SHOP_ID_KEY = "device_shop_id";
export const DEVICE_CHANGED_EVENT = "agest-device-changed";
export const DEVICE_STATUS_CHANGED_EVENT = "agest-device-status-changed";

export function notifyDeviceChanged() {
  window.dispatchEvent(new Event(DEVICE_CHANGED_EVENT));
}

export async function heartbeatDevice(token = localStorage.getItem(DEVICE_TOKEN_KEY)) {
  const deviceToken = token?.trim();
  if (!deviceToken) {
    return { error: "Este TPV todavía no está vinculado a un dispositivo", _status: 401 };
  }

  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 10000);

  try {
    const response = await fetch(`${API_URL}/devices/heartbeat`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${deviceToken}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams(),
      signal: controller.signal,
    });

    const body = await response.json().catch(() => ({}));
    const result = body && typeof body === "object" ? body : {};

    return { ...result, _status: response.status };
  } catch (_error) {
    return { error: "No se ha podido comprobar la conexión del dispositivo", _status: 0 };
  } finally {
    window.clearTimeout(timeout);
  }
}
